import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  emissionsRightList: [],
  emissionsList: [],
  orgId: undefined,
  modify: false,
  orgData: [],
};

const cpSlice = createSlice({
  name: "cp",
  initialState,
  reducers: {
    setEmissionsRightList: (state, action) => {
      state.emissionsRightList = action.payload;
    },
    setEmissionsList: (state, action) => {
      state.emissionsList = action.payload;
    },
    setOrgId: (state, action) => {
      state.orgId = action.payload;
    },
    setOrgIdMonth: (state, action) => {
      state.orgId = action.payload;
    },
    setModify: (state, action) => {
      state.modify = action.payload;
    },
    setOrgData: (state, action) => {
      state.orgData = action.payload;
    },
  },
});

export default cpSlice.reducer;
export const {
  setEmissionsRightList,
  setEmissionsList,
  setOrgId,
  setOrgIdMonth,
  setModify,
  setOrgData,
} = cpSlice.actions;
